import { FC } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ThreadDTO } from '../../api/gen/base'
import { useInvalidateThreadListQuery } from '../../api/hooks/useInvalidateThreadListQuery'
import { ConfirmDialogWrapper } from '../../components/ConfirmDialogWrapper'
import { REQUESTS_ROUTE } from '../../constants/routing.constants'
import { useDialogStore } from '../../store/storeDialog'
import { useRequestsStore } from '../../store/storeRequests'

type Props = {
    open: boolean
    handleClose: VoidFunction
    theadDetail: ThreadDTO
}

export const RequestArchiveDialog: FC<Props> = ({ open, handleClose, theadDetail }) => {
    const { archiveThread, isLoadingArchiveThread } = useDialogStore((state) => state)
    const { fetchRequestDetail } = useRequestsStore((state) => state)
    const [searchParams, setSearchParams] = useSearchParams()
    const navigate = useNavigate()

    const invalidateThreadListQuery = useInvalidateThreadListQuery()

    const handleClickArchive = async () => {
        const newIsArchived = !theadDetail.is_archived

        await archiveThread({ threadId: theadDetail.id }, { is_archived: newIsArchived })
        searchParams.set('is_archived', String(newIsArchived))
        searchParams.set('offset', '0')
        setSearchParams(searchParams)

        if (newIsArchived) {
            navigate({ pathname: REQUESTS_ROUTE, search: searchParams.toString() })
        } else {
            fetchRequestDetail({ threadId: theadDetail.id })
        }

        invalidateThreadListQuery()

        handleClose()
    }

    return (
        <ConfirmDialogWrapper
            open={open}
            handleSubmit={handleClickArchive}
            handleClose={handleClose}
            title={theadDetail.is_archived ? 'Вернуть запрос из архива?' : 'Архивировать запрос?'}
            submitButtonText={theadDetail.is_archived ? 'Разархивировать' : 'Архивировать'}
            isDisabled={isLoadingArchiveThread}>
            {theadDetail.is_archived ? (
                <> Запрос будет восстановлен. </>
            ) : (
                <>
                    Запрос будет перенесен в архив запросов. <br />
                    Вы сможете восстановить архивированный запрос.
                </>
            )}
        </ConfirmDialogWrapper>
    )
}
